import { createLogger } from './pino';
export * from './pino';

export const logger = createLogger();
